import { useKnockSlackClient as S } from "../context/KnockSlackProvider.mjs";
import { useState as l } from "react";
import "../../i18n/context/KnockI18nProvider.mjs";
import { useTranslations as g } from "../../i18n/hooks/useTranslations.mjs";
import "swr/infinite";
import { useKnockClient as E } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "fast-deep-equal";
import "date-fns";
import D from "swr";
const N = "SLACK_CONNECTED_CHANNELS";
function j({
  slackChannelsRecipientObject: {
    objectId: a,
    collection: e
  }
}) {
  const {
    t: u
  } = g(), s = E(), {
    connectionStatus: d,
    knockSlackChannelId: o
  } = S(), [p, c] = l(null), [C, r] = l(!1), {
    data: m,
    mutate: h,
    isValidating: f,
    isLoading: k
  } = D(
    // Only fetch when Slack is connected
    d === "connected" ? [N, o, e, a] : null,
    async () => s.objects.getChannelData({
      collection: e,
      objectId: a,
      channelId: o
    }).then((t) => {
      var n;
      return ((n = t.data) == null ? void 0 : n.connections) ?? [];
    }).catch(() => []),
    {
      onSuccess: () => {
        c(null);
      }
    }
  );
  return {
    data: m ?? null,
    updateConnectedChannels: async (t) => {
      r(!0);
      try {
        await h(() => s.objects.setChannelData({
          objectId: a,
          collection: e,
          channelId: o,
          data: {
            connections: t
          }
        }).then((n) => {
          var i;
          return ((i = n.data) == null ? void 0 : i.connections) ?? [];
        }), {
          populateCache: !0,
          revalidate: !1,
          optimisticData: t
        });
      } catch {
        c(u("slackChannelSetError") || "");
      }
      r(!1);
    },
    updating: C,
    loading: k || f,
    error: p
  };
}
export {
  j as default
};
//# sourceMappingURL=useConnectedSlackChannels.mjs.map
